<template lang="pug">
.badges.d-flex
  AppAchievementBadge(
    v-for="(achievement, i) in list"
    :key="i"
    :achievement="achievement"
    :size="size"
    :max="max"
    @mouseover-badge="$emit('mouseover-badge')"
  )
</template>

<script>
import AppAchievementBadge from '~/components/AppAchievementBadge.vue';

export default {
  name: 'AppAchievementBadges',
  components: {
    AppAchievementBadge,
  },
  props: {
    achievements: {
      type: Array,
      required: true,
    },
    size: {
      type: String,
      default: 'small',
    },
    max: {
      type: Number,
      default: 999,
    },
  },
  computed: {
    list() {
      return Object.values(
        this.achievements.reduce((c, {category, title}) => {
          c[category] = c[category] || { category, count: 0, title };
          c[category].count += 1

          return c;
        }, {}),
      );
    },
  },
};
</script>
